import { IonButton, IonIcon } from "@ionic/react";
import { addSharp } from "ionicons/icons";
import { useDispatch, useSelector } from "react-redux";
import { addQuestionToList } from "../../../store/templateDetail";
import { selectQuestionList } from "../../../store/templateDetail/selectors/selectQuestionList";

export const AddQuestionButton = () => {
  const dispatch = useDispatch();
  const listLength = useSelector(selectQuestionList).length;

  return (
    <IonButton
      color="secondary"
      onClick={() => dispatch(addQuestionToList({ order: listLength + 1, type: "text" }))}
    >
      <IonIcon icon={addSharp} slot="start" />
      AGREGAR PREGUNTA
    </IonButton>
  );
};
